import { render, staticRenderFns } from "./MDW.vue?vue&type=template&id=30130010&scoped=true&"
import script from "./MDW.vue?vue&type=script&lang=js&"
export * from "./MDW.vue?vue&type=script&lang=js&"
import style0 from "./MDW.vue?vue&type=style&index=0&id=30130010&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30130010",
  null
  
)

export default component.exports